import { useAuth } from "@shared/lib/auth"
import {
	AnalyticsShell,
	NOT_AVAILABLE,
} from "@sustainability/analytics-frontend"
import { useTranslation } from "react-i18next"

interface AnalyticsShellProviderProps {
	children: React.ReactNode
}

export const AnalyticsShellProvider: React.FC<AnalyticsShellProviderProps> = ({
	children,
}) => {
	const { i18n } = useTranslation()

	const { isAuthenticated, userData } = useAuth()

	return (
		<AnalyticsShell
			configuration={{
				appName: import.meta.env.VITE_APP_NAME,
				appEnvironment: import.meta.env.MODE,
				trackPageChanges: true,
				locationKey: location.pathname + location.search,
				allowTracking: true,
				anonymizeSensitiveData: true,
				connectionString: import.meta.env
					.VITE_ANALYTICS_CONNECTION_STRING,
				includeEventTimestamp: true,
				maxBatchInterval: 10000,
			}}
			eventProperties={{
				product: import.meta.env.VITE_APP_NAME,
				userId: isAuthenticated
					? userData?.id || NOT_AVAILABLE
					: NOT_AVAILABLE,
				appVersion: import.meta.env.VITE_APP_VERSION,
				resolvedLanguage: i18n.resolvedLanguage ?? NOT_AVAILABLE,
			}}
		>
			{children}
		</AnalyticsShell>
	)
}
